import { Table } from '@ui/src';
import { BeneficiaryTablesTypes } from '../types';
import {
  columns as contractsColumns,
  columnsLabels as contractsColumnsLabels,
} from '../../../../hoc/common/beneficiaries/variables/contracts';
import {
  columns as documentsColumns,
  columnsLabels as documentsColumnsLabels,
} from '../../../../hoc/common/beneficiaries/variables/documents';

import cn from '../styles.module.css';

const BeneficiaryTables = ({
  beneficiarySettings,
  contractsFormattedData,
  filters,
  contractsIsLoading,
  contractsIsFetching,
  beneficiaryContracts,
  beneficiary,
  formattedDocumentsData,
  documentsCategoriesIsLoading,
  documentsCategoriesIsFetching,
  onRowClick,
  errors,
  beneficiaryContractsErrorsList,
}: BeneficiaryTablesTypes) => (
  <>
    {beneficiarySettings?.find(
      (item) => item.key === 'CORPORATE-BENEFICIARIES-CONTRACTS-ENABLED',
    )?.data.value && (
      <div className={cn.contractsWrapper}>
        <div className={cn.contractsTitle}>Contracts</div>
        <Table
          columns={contractsColumns}
          data={contractsFormattedData || []}
          onSort={() => {}}
          filters={filters}
          sort={{}}
          columnsLabels={contractsColumnsLabels}
          isLoading={contractsIsLoading || contractsIsFetching}
          tableClassName={
            !beneficiaryContracts?.length ||
            contractsIsLoading ||
            contractsIsFetching
              ? cn.contractsEmpty
              : ''
          }
          tableTopClassName={cn.beneficiaryTableTop}
          onFilterChange={() => {}}
          error={beneficiaryContractsErrorsList}
          take="20"
          clickable
        />
      </div>
    )}
    {beneficiary?.paymentType === 'CASH_OVER_COUNTER' && (
      <div className={cn.documentsWrapper}>
        <div className={cn.contractsTitle}>Documents</div>
        <Table
          columns={documentsColumns}
          data={formattedDocumentsData || []}
          onSort={() => {}}
          filters={{}}
          sort={{}}
          columnsLabels={documentsColumnsLabels}
          isLoading={
            documentsCategoriesIsLoading || documentsCategoriesIsFetching
          }
          tableClassName={
            !beneficiary?.documents?.edges?.length ||
            documentsCategoriesIsLoading ||
            documentsCategoriesIsFetching
              ? cn.contractsEmpty
              : ''
          }
          onRowClick={onRowClick}
          tableTopClassName={cn.beneficiaryTableTop}
          onFilterChange={() => {}}
        />
        {errors?.documents?.message && (
          <div
            className={`${cn.beneficiaryContentRowError} ${cn.documentsErrors}`}
          >
            {errors?.documents?.message}
          </div>
        )}
      </div>
    )}
  </>
);

export default BeneficiaryTables;
